import { action } from 'typesafe-actions';

import { KnmErknmActionsEnum } from '../enums/KnmErknmActionsEnum';
import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { FieldsForApproving } from '../types/FieldsForApproving';

export const knmErknmInitSelectOptions = () => action(KnmErknmActionsEnum.KNM_ERKNM_INIT_SELECT_OPTIONS);
export const knmErknmSetInitialFormValues = (initialFormValues: IKnmErknmForm) =>
  action(KnmErknmActionsEnum.KNM_SET_INITIAL_FORM_VALUES, { initialFormValues });
export const knmErknmResetInitialFormValues = () => action(KnmErknmActionsEnum.KNM_ERKNM_RESET_INITIAL_FORM_VALUES);
export const knmErknmSetFieldsForApproving = (fieldsForApproving?: FieldsForApproving) =>
  action(KnmErknmActionsEnum.KNM_ERKNM_SET_FIELDS_FOR_APPROVING, { fieldsForApproving });
export const knmErknmSetIsShowMessageByStatus = (isShowMessageByStatus: boolean) =>
  action(KnmErknmActionsEnum.KNM_ERKNM_SET_IS_SHOW_MESSAGE_BY_STATUS, { isShowMessageByStatus });
export const knmErknmSetWasFirstInit = (wasFirstInit: boolean) =>
  action(KnmErknmActionsEnum.KNM_ERKNM_SET_WAS_FIRST_INIT, { wasFirstInit });
export const knmErknmSetPrescriptionOldRules = (value: boolean | undefined) =>
  action(KnmErknmActionsEnum.KNM_ERKNM_SET_PRESCRIPTION_OLD_RULES, { value });
export const knmErknmSetPrescriptionFailed = (value: boolean | undefined) =>
  action(KnmErknmActionsEnum.KNM_ERKNM_SET_PRESCRIPTION_FAILED, { value });
